import {
	GET_MISSTATEMENTS_BY_DOCUMENTID,
	GET_MISSTATEMENTS,
	UPDATE_MISSTATEMENT,
	GET_ALL_MISSTATEMENTS,
	DELETE_MISSTATEMENT_BY_ID
} from '../../actions/actiontypes';
import {isApiResponseOk} from '../../util/utils';
import initialstate from '../initialstate';
import {cloneDeep, isEmpty} from 'lodash';

export default function misstatementsReducer(state = initialstate.misstatements, action) {
	switch (action.type) {
		case GET_MISSTATEMENTS_BY_DOCUMENTID:
			if (action.response) {
				return !_.isEmpty(action.response)
					? action.response
					: {
							totalEntityCount: 0,
							pages: 1,
							page: 1,
							data: []
					  };
			}
			break;
		case GET_MISSTATEMENTS:
			if (isApiResponseOk(action)) {
				if (action.response.data.length > 0) {
					action.response.data = action.response.data.map((item) => {
						return {
							...item,
							id: item.misstatementId
						};
					});
				}
				return {
					...state,
					...(action.response || {
						totalEntityCount: 0,
						pages: 1,
						page: 1,
						data: []
					})
				};
			}
			break;
		case UPDATE_MISSTATEMENT: {
			if (!isEmpty(action.response)) {
				let newState = cloneDeep(state);
				const editIndex = newState?.data?.findIndex(
					(misstatement) => misstatement.misstatementId === action.response?.misstatementId
				);

				if (editIndex !== -1) {
					newState.data[editIndex] = {...action.response};
				}
				return {
					...newState
				};
			}
			return state;
		}
		case GET_ALL_MISSTATEMENTS:
			if (isApiResponseOk(action)) {
				let newState = null;
				if (action.response.data.length > 0) {
					newState = action.response.data.map((item) => {
						return {
							...item,
							id: item.misstatementId
						};
					});
					if (action.response.page != 1) {
						newState = [...state?.data, ...newState];
					}
					newState = {
						totalEntityCount: action.response?.totalEntityCount,
						pages: action.response?.pages,
						page: action.response?.page,
						data: newState
					};
				}

				return {
					...state,
					...(newState || {
						totalEntityCount: 0,
						pages: 1,
						page: 1,
						data: []
					})
				};
			}
			break;
		case DELETE_MISSTATEMENT_BY_ID:
			if (isApiResponseOk(action) && action.misstatementId) {
				let newState = cloneDeep(state);
				const deleteIndex = newState?.data?.findIndex(
					(misstatement) => misstatement.misstatementId.toString() === action.misstatementId
				);

				if (deleteIndex !== -1) {
					newState.data.splice(deleteIndex, 1);
				}
				return {
					...newState
				};
			}
			return state;
		default:
			return state;
	}
}
